export default "__VITE_ASSET__8a3b094b__"